import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { customerMobileAuthNumberPost } from '../../../../api-client/api-gqcust-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const postCustomerMobileAuthNumber = createAsyncThunk(
    'postCustomerMobileAuthNumber/Post',
    async (body, { rejectWithValue }) => {
        try {
            const response = await customerMobileAuthNumberPost(body);
            const data = response.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'POST_CUSTOMER_MOBILE_AUTH_NUMBER_FAILURE',
                error: err,
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

export const postCustomerMobileAuthNumberSlice = createSlice({
    name: 'postCustomerMobileAuthNumber',
    initialState,
    extraReducers: {
        [postCustomerMobileAuthNumber.pending]: (state) => {
            state.loading = true;
        },
        [postCustomerMobileAuthNumber.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
        },
        [postCustomerMobileAuthNumber.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const postCustomerMobileAuthNumberSelector = (state) => state.postCustomerMobileAuthNumber;
export const postCustomerMobileAuthNumberReducer = postCustomerMobileAuthNumberSlice.reducer;
